import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Upload from './pages/Upload';
import UploadAdmin from './pages/UploadAdmin';
import Dashboard from "./components/Dashboard";
import Account from "./pages/Account";
import Home from "./pages/Home";
import Settings from "./pages/Settings";

import "./App.css";

import useAuthCheck from "./hooks/userAuthCheck";
import useUserData from "./hooks/userData";


function App() {
    const [sidebarOpen, setSidebarOpen] = React.useState(false);
    const userData = useUserData()
    const userRole = userData?.role; // Assuming userData contains the role information
    const userEmail = userData?.email; // Assuming userData contains the email information
    
    useAuthCheck(); // Automatically logs out if refresh token expires    
    
    return (
        <Router>
            <div className="app-wrapper">
                {/* Public Routes */}
                {(userRole === undefined || userRole === null) && (
                    <>
                        <Routes>
                            <Route path="/" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                        </Routes>
                    </>
                )}
                
                {/* Customer Routes */}
                {userRole === "customer" && (
                    <>
                        <Dashboard open={sidebarOpen} setOpen={setSidebarOpen} userRole={userRole}/>
                        <div className={`main-content ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/account" element={<Account userEmail={userEmail} />} />
                                <Route path="/upload" element={<Upload />} />
                                <Route path="/settings" element={<Settings />} />
                            </Routes>
                        </div>
                    </>
                )}
                {/* Admin Routes */}
                {userRole === "admin" && (
                    <>
                        <Dashboard open={sidebarOpen} setOpen={setSidebarOpen} userRole={userRole}/>
                        <div className={`main-content ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/account" element={<Account userEmail = {userEmail}/>} />
                                <Route path="/upload" element={<UploadAdmin />} />

                            </Routes>
                        </div>
                    </>
                )}

            </div>
        </Router>
    );
}

export default App;